<div class="starter-template">
  <app-enter-question></app-enter-question>
  <!-- <a routerLink="/history">History</a> -->
</div>
